<template>
  <v-list-item two-line>
    <v-list-item-avatar>
      <v-icon>mdi-account</v-icon>
    </v-list-item-avatar>

    <v-list-item-content :class="{ 'grey--text': !user.isActive }">
      <v-list-item-title>
        {{ user.fullName }}
        <small v-if="!user.isActive" class="font-italic font-weight-light">Nieaktywny</small>
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ roles }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action class="mr-4">
      <ChangeUserPasswordModal :user="user" />
    </v-list-item-action>

    <v-list-item-action>
      <UpdateUserModal :user="user" />
    </v-list-item-action>

    <v-list-item-action>
      <DeleteUserModal :user-id="user.id" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import UpdateUserModal from '@/components/manage/users/manage-user/UpdateUserModal.vue';
import ChangeUserPasswordModal from '@/components/manage/users/manage-user/ChangeUserPasswordModal.vue';
import DeleteUserModal from '@/components/manage/users/manage-user/DeleteUserModal.vue';

export default {
  components: {
    UpdateUserModal,
    ChangeUserPasswordModal,
    DeleteUserModal
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    roles() {
      const roleList = this.user.roleNames.map(role => {
        const result =
          role === 'ADMIN'
            ? 'Administrator'
            : role === 'COURSEADMIN'
            ? 'Administrator szkoleń'
            : role === 'TEACHER'
            ? 'Nauczyciel'
            : role === 'STUDENT'
            ? 'Student'
            : null;

        if (!result) {
          throw 'Unhandled role name';
        }

        return result;
      });

      return roleList.join(' / ');
    }
  }
};
</script>
